import { Utils } from '../../app.base';
import { MsgBox, Vue } from '../../app.vues';
import SwbShopDeviceImpItemLowCostList from './ShopDeviceImpItemLowCostList';
Vue.regist(SwbShopDeviceImpItemLowCostList);
import SwbShopDeviceIoInVoucherLowCostDetail from './ShopDeviceIoInVoucherLowCostDetail';
Vue.regist(SwbShopDeviceIoInVoucherLowCostDetail);
import SwbShopDeviceLowCostDetail from './ShopDeviceLowCostDetail';
Vue.regist(SwbShopDeviceLowCostDetail);

//机构设备-详情
export function openShopDeviceDetailDlg(shopDevice) {
    Vue.$showDialog({
        title: "机构耗材详情",
        width: 800,
        height: 700,
        okVisible: false,
        showCloseBtn: true,
        cancelText: '关闭',
        template: '<div>' +
        '<swb-shop-device-lowcost-detail :shopDevice="shopDevice"></swb-shop-device-lowcost-detail>' +
        '</div>',
        data: {
            shopDevice: shopDevice
        }
    });
};

//机构设备导入详细列表
export function openShopDeviceIoVoucherDetailDlg(id, callback) {
    let theDlg = Vue.$showDialog({
        title: "耗材入库单详情",
        width: "90%",
        height: "90%",
        okVisible: false,
        showCloseBtn: true,
        cancelText: '关闭',
        template: '<div>' +
        '<swb-shop-device-ioIn-voucher-lowCost-detail :voucherId="id"  ref="swb_shop_device_ioIn_voucher_lowCost_detail"></swb-shop-device-ioIn-voucher-lowCost-detail>' +
        '</div>',
        data: {
            id: id,
        },
        methods: {
            theDlgClose: function () {
                theDlg.close();
            }
        }
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/compo/ShopDeviceLowCost/selectDlg.js
// module id = 260
// module chunks = 0